import { FaroTextButton } from "@components/common/faro-text-button";
import {
  BulkRemoveMemberDialog,
  BulkRemoveMemberDialogProps,
} from "@components/table/members/bulk-actions/bulk-remove-member-dialog";
import { RemoveMemberBase } from "@components/table/members/bulk-actions/bulk-remove-member-types";
import { useState } from "react";
import { getBulkActionButtonConfig } from "@components/common/faro-table/bulk-actions/bulk-actions-config";
import { Text, DeleteIcon } from "@flat-ui";
import { useBulkActionsMode } from "@hooks/use-bulk-actions-mode";

/** Props for the bulk remove member button */
type RemoveMember = RemoveMemberBase & {
  /**
   * Title for the bulk action button.
   * @default "Remove members"
   */
  title?: string;
};

/** Show remove member button and dispatch action where the bulk dialog will act accordingly */
export function BulkRemoveMember({
  title = "Remove members",
  ...props
}: RemoveMember): JSX.Element {
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);
  const mode = useBulkActionsMode();

  const config = getBulkActionButtonConfig(
    mode,
    `Remove member from ${props.subjectType}`
  );

  return (
    <>
      <FaroTextButton
        onClick={() => setIsDialogOpen(true)}
        tooltipText={config.tooltipText}
        sx={{ ...config.sx }}
        startIcon={<DeleteIcon sx={{ width: "18px", height: "18px" }} />}
        rippleColor={config.rippleColor}
      >
        {config.shouldShowText && <Text variant="buttonM">{title}</Text>}
      </FaroTextButton>

      <BulkRemoveMemberDialog
        {...(props as BulkRemoveMemberDialogProps)}
        isOpen={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
      />
    </>
  );
}
